import { useTheme } from "../context/ThemeContext";
import { BsMoonFill, BsSunFill } from "react-icons/bs";
import { useLocation } from "react-router-dom"; // Import the hook

const ThemeToggle = ({ isMobile }) => {
  const { darkMode, setDarkMode } = useTheme();
  const location = useLocation(); // Use the hook to get the current path

  // If the path is "/admin-dashboard-login" or "/admin-dashboard", don't render the theme toggle
  if (location.pathname === "/admin-dashboard-login" || location.pathname === "/admin-dashboard")
    return null;

  return (
    <button
      onClick={() => setDarkMode(!darkMode)}
      className={`${
        isMobile
          ? "w-full text-left px-4 py-2 text-sm rounded-md bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-600 flex items-center gap-2"
          : "p-2 rounded-full bg-gray-200 dark:bg-gray-800 text-gray-900 dark:text-white shadow-md transition-all duration-300 hover:scale-110"
      }`}
    >
      {darkMode ? (
        <span className="flex items-center gap-2">
          <BsSunFill className="text-yellow-400" /> {isMobile && "Light"}
        </span>
      ) : (
        <span className="flex items-center gap-2">
          <BsMoonFill /> {isMobile && "Dark"}
        </span>
      )}
    </button>
  );
};

export default ThemeToggle;
